export const translations = {
  en: {
    nav: {
      brand: 'Francesco Alessandro Cuzzola — Personal Website',
      home: 'Home', cv: 'CV', competences: 'Competences',
      publications: 'Publications', honors: 'Honors', contacts: 'Contacts', blog: 'Blog',
    },
    hero: {
      subtitle: 'Information & Control Systems Technology Engineer',
      cta_cv: 'View CV', cta_blog: 'Read Blog',
      tagline: 'Engineer · Researcher · Associate Editor · EMBA',
      bio: 'Engineering, research, and industrial transformation rarely speak the same language. Francesco Alessandro Cuzzola has spent over 25 years making them converge. His industrial career has taken him from the shopfloor to the boardroom: he has held executive and senior technical roles within companies at the core of the global metals and energy industries, founded technology startups, and led digital transformation programmes across international operations and multidisciplinary teams. He subsequently brought that industrial depth into academic research, joining Politecnico di Milano where he coordinates European Horizon consortia at the frontier of industrial artificial intelligence, autonomous production systems, and decarbonisation of energy-intensive industries. His work has been recognised by the international industrial & research community through multiple awards and editorial appointments, and consistently aims at outcomes that travel from the laboratory to the factory floor.',
    },
    sections: {
      cv: 'Curriculum Vitae', work: 'Work Experience', education: 'Education',
      competences: 'Competences', publications: 'Publications',
      honors: 'Honors & Awards', contacts: 'Contacts', blog: 'Blog',
    },
    pub_types: { journal: 'Journal Papers', book: 'Books & Chapters', conference: 'Conference Papers' },
    cv: { present: 'Present' },
    blog: {
      latest: 'Latest Posts', all_posts: 'All Posts', read_more: 'Read More',
      save: 'Save for Later', remove: 'Remove', stored_title: 'Saved Posts',
      no_stored: 'You have no saved posts.',
      comments: 'Comments', add_comment: 'Leave a Comment',
      name_label: 'Your Name', email_label: 'Your Email (optional)',
      text_label: 'Your Comment', submit: 'Submit Comment',
      thanks: 'Thank you! Your comment is awaiting approval.',
      no_comments: 'No comments yet. Be the first!',
      back: '← Back to Blog',
      subscribe_hero_cta: '✉️ Get new posts by email',
      subscribe_title: 'Never miss a post.',
      subscribe_intro: 'New articles, straight to your inbox. No spam — unsubscribe in one click.',
      subscribe_email: 'Email address',
      subscribe_first: 'First name (optional)',
      subscribe_last: 'Last name (optional)',
      subscribe_lang: 'Notification language',
      subscribe_consent: 'I agree to receive blog post notifications by email and can unsubscribe anytime.',
      subscribe_note: "We only use your email to send new posts. Unsubscribe anytime, or contact f.cuzzola@gmail.com to access, correct, or delete your data.",
      subscribe_submit: 'Subscribe',
      subscribe_sending: 'Subscribing…',
      subscribe_success: 'You are subscribed. Thank you!',
      subscribe_error: 'Something went wrong. Please try again.',
      subscribe_consent_required: 'Please accept the privacy notice to subscribe.',
      subscribe_email_required: 'Please enter a valid email address.',
      unsub_loading: 'Processing your request…',
      unsub_success: "You're all set—you won't receive any more blog emails.",
      unsub_error: 'This unsubscribe link is invalid or has expired.',
      unsub_back: '← Back to Blog',
    },
    contacts: {
      find_me: 'Find me on',
      message: 'Or use the form below to send me a message. I will get back to you as soon as possible.',
      form_name: 'Your Name', form_email: 'Your Email', form_subject: 'Subject', form_message: 'Message',
      form_submit: 'Send Message', form_sending: 'Sending…',
      form_success: 'Message sent! I will get back to you soon.',
      form_error: 'Something went wrong. Please try again.',
      form_required: 'All fields are required.',
    },
    loading: 'Loading…',
    toggle_lang: 'IT',
  },
  it: {
    nav: {
      brand: 'Francesco Alessandro Cuzzola — Sito Personale',
      home: 'Home', cv: 'CV', competences: 'Competenze',
      publications: 'Pubblicazioni', honors: 'Riconoscimenti', contacts: 'Contatti', blog: 'Blog',
    },
    hero: {
      subtitle: 'Ingegnere dei Sistemi Informatici e di Controllo',
      cta_cv: 'Vedi CV', cta_blog: 'Leggi Blog',
      tagline: 'Ingegnere · Ricercatore · Associate Editor · EMBA',
      bio: 'Ingegneria, ricerca e trasformazione industriale raramente parlano la stessa lingua. Francesco Alessandro Cuzzola ha trascorso oltre 25 anni a farle convergere. La sua carriera industriale lo ha portato dalla fabbrica alla sala del consiglio: ha ricoperto ruoli esecutivi e tecnici di alto livello in aziende al cuore dei settori metallurgico ed energetico globale, ha fondato startup tecnologiche e ha guidato programmi di trasformazione digitale in operazioni internazionali e team multidisciplinari. Ha poi portato questa profondità industriale nella ricerca accademica, entrando al Politecnico di Milano dove coordina consorzi europei Horizon alla frontiera dell\'intelligenza artificiale industriale, dei sistemi di produzione autonomi e della decarbonizzazione delle industrie ad alta intensità energetica. Il suo lavoro è stato riconosciuto dalla comunità scientifica internazionale attraverso numerosi premi e incarichi editoriali, e mira costantemente a risultati che viaggiano dal laboratorio al pavimento della fabbrica.',
    },
    sections: {
      cv: 'Curriculum Vitae', work: 'Esperienza Lavorativa', education: 'Istruzione',
      competences: 'Competenze', publications: 'Pubblicazioni',
      honors: 'Premi e Riconoscimenti', contacts: 'Contatti', blog: 'Blog',
    },
    pub_types: { journal: 'Articoli su Riviste', book: 'Libri e Capitoli', conference: 'Articoli a Conferenze' },
    cv: { present: 'Presente' },
    blog: {
      latest: 'Ultimi Post', all_posts: 'Tutti i Post', read_more: 'Leggi Tutto',
      save: 'Salva per Dopo', remove: 'Rimuovi', stored_title: 'Post Salvati',
      no_stored: 'Non hai post salvati.',
      comments: 'Commenti', add_comment: 'Lascia un Commento',
      name_label: 'Il Tuo Nome', email_label: 'La Tua Email (opzionale)',
      text_label: 'Il Tuo Commento', submit: 'Invia Commento',
      thanks: 'Grazie! Il tuo commento è in attesa di approvazione.',
      no_comments: 'Nessun commento ancora. Sii il primo!',
      back: '← Torna al Blog',
      subscribe_hero_cta: '✉️ Iscriviti alle notifiche',
      subscribe_title: 'Non perderti nessun articolo.',
      subscribe_intro: 'Nuovi articoli direttamente nella tua inbox. Niente spam — disiscrizione in un clic.',
      subscribe_email: 'Indirizzo email',
      subscribe_first: 'Nome (opzionale)',
      subscribe_last: 'Cognome (opzionale)',
      subscribe_lang: 'Lingua delle notifiche',
      subscribe_consent: 'Acconsento a ricevere le notifiche dei nuovi articoli via email e posso annullare l\'iscrizione quando voglio.',
      subscribe_note: 'Usiamo la tua email solo per inviarti i nuovi articoli. Puoi disiscriverti quando vuoi, o contattare f.cuzzola@gmail.com per accedere, correggere o cancellare i tuoi dati.',
      subscribe_submit: 'Iscriviti',
      subscribe_sending: 'Iscrizione in corso…',
      subscribe_success: 'Iscrizione completata. Grazie!',
      subscribe_error: 'Qualcosa è andato storto. Riprova.',
      subscribe_consent_required: 'Accetta l\'informativa sulla privacy per iscriverti.',
      subscribe_email_required: 'Inserisci un indirizzo email valido.',
      unsub_loading: 'Elaborazione della richiesta…',
      unsub_success: 'Perfetto, non riceverai più email dal blog.',
      unsub_error: 'Questo link di annullamento non è valido o è scaduto.',
      unsub_back: '← Torna al Blog',
    },
    contacts: {
      find_me: 'Trovami su',
      message: 'Oppure usa il form qui sotto per inviarmi un messaggio. Ti risponderò appena possibile.',
      form_name: 'Il tuo nome', form_email: 'La tua email', form_subject: 'Oggetto', form_message: 'Messaggio',
      form_submit: 'Invia messaggio', form_sending: 'Invio in corso…',
      form_success: 'Messaggio inviato! Ti risponderò presto.',
      form_error: 'Qualcosa è andato storto. Riprova.',
      form_required: 'Tutti i campi sono obbligatori.',
    },
    loading: 'Caricamento…',
    toggle_lang: 'EN',
  },
}

export const t = (lang, path) => {
  const keys = path.split('.')
  let val = translations[lang] || translations['en']
  for (const k of keys) val = val?.[k]
  return val ?? path
}
